import React, { useState } from "react";
import UploadPdf from "../../../../../assets/icons/UploadPdfIcon";
import { PrimaryButton } from "../../../../../components/primary/PrimaryButton";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import ArrowedDocumentIcon from "../../../../../assets/icons/ArrowedDocument";
import { UploadFilesComponent } from "../steps/UploadFilesComponent";
import DownloadPdf from "../../../../../assets/icons/DownloadPdfIcon";
import { PDFDownloadLink } from "@react-pdf/renderer";
import UserContract from "../../../../../features/Pdfs/UserContract";
import "./index.css";

const Select = ({ step, setStep, land, client }) => {
  console.log("client", client);
  if (step === 1) {
    return (
      <>
        <div
          className="p-10"
          style={{
            backgroundColor: "rgba(105, 178, 200, 0.2)",
            borderRadius: "50%",
          }}
        >
          <DownloadPdf size="80" />
        </div>
        <p className="text-primary mb-1 text-[18px] mt-5">
          Conoce y descarga tu contrato
        </p>
        {/*<PrimaryButton>Descargar</PrimaryButton>*/}
        <PDFDownloadLink
          document={
            <UserContract
              fullName={`${client?.name} ${client?.last_name}`}
              land={client.client.lands[0]}
            />
          }
          fileName="contrato.pdf"
          className="primary-btn-size text-white cursor-pointer primary-btn-text rounded-md bg-gradient-to-r from-btnPrimaryFrom to-btnPrimaryTo uppercase"
          style={{
            textAlign: "center",
            textDecoration: "none",
            alignContent: "center",
          }}
        >
          {({ loading }) => (loading ? "Generando PDF..." : "Descargar")}
        </PDFDownloadLink>
      </>
    );
  }

  return (
    <>
      <div
        className="p-10"
        style={{
          backgroundColor: "rgba(105, 178, 200, 0.2)",
          borderRadius: "50%",
        }}
      >
        <UploadPdf size="80" />
      </div>
      <p className="text-primary mb-1 text-[18px] mt-5">
        Sube y envía tu contrato
      </p>
      <UploadFilesComponent
        land={land}
        client={client}
        documentType={"contrato"}
        renderComponent={() => <PrimaryButton>Enviar</PrimaryButton>}
      />
    </>
  );
};

const Contract = ({ land, client }) => {
  const [step, setStep] = useState(1);

  return (
    <div className="flex flex-col items-center justify-center mt-10 mb-3">
      {/* <div
        className="p-10"
        style={{
          backgroundColor: "rgba(105, 178, 200, 0.2)",
          borderRadius: "50%",
        }}
      >
        <DownloadPdf size="80" />
      </div>
      <p className="text-primary mb-1 text-[18px] mt-5">
        Conoce y descarga tu contrato
      </p>
      <PrimaryButton>Descargar</PrimaryButton>*/}
      <Select step={step} setStep={setStep} land={land} client={client} />

      <div className="flex flex-col items-center justify-center mt-5 mb-3">
        <p className="text-primary mb-1 text-[18px] mt-5">Paso {step}-2</p>
        <div className="flex flex-row items-center justify-center gap-5">
          <button
            disabled={step === 1}
            onClick={() => {
              setStep(1);
            }}
            style={{ opacity: step === 1 ? 0.5 : 1 }}
            variant="inner"
            className="bg-gradient-to-r from-btnPrimaryFrom to-btnPrimaryTo rounded-sm px-2 py-1 shadow-md"
          >
            <IoIosArrowBack size={20} color="#ffff" />
          </button>
          <button
            disabled={step === 2}
            onClick={() => {
              setStep(2);
            }}
            style={{ opacity: step === 2 ? 0.5 : 1 }}
            variant="inner"
            className="bg-gradient-to-r from-btnPrimaryFrom to-btnPrimaryTo rounded-sm px-2 py-1 shadow-md"
          >
            <IoIosArrowForward size={20} color="#ffff" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Contract;
